export var ServerRequestType;
(function (ServerRequestType) {
    ServerRequestType["CircleAddToCircle"] = "CircleAddToCircle";
    ServerRequestType["CircleFollowUser"] = "CircleFollowUser";
    ServerRequestType["CircleCreateTieUser"] = "CircleCreateTieUser";
    ServerRequestType["CircleDeleteFollowingUser"] = "CircleDeleteFollowingUser";
    ServerRequestType["CommonSendFeedback"] = "CommonSendFeedback";
    ServerRequestType["CommentGetComments"] = "CommentGetComments";
})(ServerRequestType || (ServerRequestType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/serverRequestType.ts
// module id = 89
// module chunks = 50